'use client';

import { useLang } from '@/lib/i18n/LanguageContext';

// Cross-promo traka za FX Doctor: linkuje ka novoj /analiza-zlata stranici na
// fxdoctor.pro (XAU/USD multi-timeframe analiza). Nema svoj API poziv, samo
// staticna traka odmah ispod Navbar-a na marketing landing stranici — isti
// tamno-zlatni ton kao na samoj FX Doctor stranici, da se vizuelno poveze.
export default function FxDoctorGoldBanner() {
  const { t } = useLang();

  return (
    <a
      href="https://fxdoctor.pro/analiza-zlata"
      target="_blank"
      rel="noopener noreferrer"
      className="fxdoc-gold-strip"
      aria-label={t('Gold price analysis on FX Doctor')}
      style={{ textDecoration: 'none', display: 'block' }}
    >
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .fxdoc-gold-strip { background: #0b1220; border-bottom: 1px solid #1c2740; transition: background-color 0.15s ease; }
            .fxdoc-gold-strip:hover { background: #16233a; }
            .fxdoc-gold-strip:hover .fxdoc-gold-strip-arrow { transform: translateX(4px); }
          `,
        }}
      />
      <div
        className="max-w-screen-2xl mx-auto flex items-center gap-4 flex-wrap"
        style={{ padding: '10px 16px' }}
      >
        <span
          className="font-mono-nums"
          style={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: '#e0c26b',
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
        >
          FX DOCTOR
        </span>
        <span style={{ fontSize: 13.5, fontWeight: 600, color: '#ffffff', flex: '1 1 260px', minWidth: 200 }}>
          {t('Gold (XAU/USD) analysis — D1, H4, H1 and M15 in one place')}
        </span>
        <span
          className="font-mono-nums"
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: '#e0c26b',
            whiteSpace: 'nowrap',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            flexShrink: 0,
          }}
        >
          {t('Read the analysis')}
          <span className="fxdoc-gold-strip-arrow" style={{ transition: 'transform 0.15s ease' }} aria-hidden>
            →
          </span>
        </span>
      </div>
    </a>
  );
}
